export const commonData = [
  {
    id: 'common_1',
    brand: 'common',
    category: '가슴',
    name: '체스트 프레스 머신',
    target: '윗가슴 (상부 대흉근)',
    images: [
      '/images/machine/common/chest_press.png',
    ],
    image_des:'/images/machine/common/2_chest.png',
    feature: [
      "의자 높이 조절: 앉았을 때 손잡이(그립)의 위치가 겨드랑이 선이나 가슴 중앙(유두 선)에 오도록 의자 높이를 맞춥니다.",
      "기본 자세: 엉덩이와 등, 머리를 등받이에 바짝 붙이고, 허리는 손바닥 하나가 겨우 들어갈 정도로만 살짝 띄워 아치(arch)를 만듭니다. 발바닥은 지면에 단단히 고정합니다.",
      "밀기 (수축): 호흡을 내쉬며 겨드랑이에 힘을 준다는 느낌으로 손잡이를 앞으로 밀어줍니다. 이때 팔꿈치를 완전히 쫙 펴서 관절에 무리가 가지 않도록 95%만 편다는 느낌을 유지합니다.",
      "당기기 (이완): 호흡을 들이마시며 가슴 근육이 늘어나는 것을 느끼며 천천히 시작 자세로 돌아옵니다. 이때 무게추가 완전히 닿지 않도록 긴장감을 유지합니다."
    ],
    tip: [
      "어깨 고정(숄더 패킹): 날개뼈(견갑골)를 모아서 등받이에 단단히 고정해야 합니다. 어깨가 앞으로 말리거나 위로 으쓱 솟으면 가슴이 아닌 어깨 통증을 유발할 수 있습니다.",
      "수직 동선 유지: 밀고 당길 때 팔꿈치의 각도가 바닥과 수평을 이루며 손목-팔꿈치가 일직선상에서 움직여야 힘이 온전히 가슴으로 전달됩니다. 손목이 뒤로 꺾이지 않도록 주의하세요."
    ]
  },
  {
    id: 'common_2',
    brand: 'common',
    category: '등',
    name: '랫풀다운 머신',
    target: '광배근 (등 전체 및 상부)',
    images: [
      '/images/machine/common/latpulldown.png', 
    ],
    image_des:'/images/machine/common/2_latpull.png',
    feature: [
      "패드 조절 및 그립 잡기: 허벅지가 들리지 않도록 지지대 패드 높이를 조절하고, 바를 어깨너비보다 넓게 오버그립(손등이 하늘을 보게)으로 잡습니다.",
      "기본 자세: 바를 잡고 자리에 앉아 허벅지를 패드에 고정합니다. 가슴을 위로 살짝 들어 올리고(흉추 신전), 허리는 곧게 폅니다.",
      "당기기 (수축): 호흡을 내쉬며 바가 쇄골 아랫부분에 닿는다는 느낌으로 수직으로 당겨 내립니다. 이때 팔로 당기는 것이 아니라 팔꿈치를 옆구리에 붙인다는 느낌으로 등을 접어줍니다.",
      "놓아주기 (이완): 호흡을 들이마시며 등의 긴장감을 유지한 채, 바를 천천히 위로 올려주며 광배근을 늘려줍니다. 어깨가 완전히 으쓱 위로 딸려 올라가지 않도록 주의합니다."
    ],
    tip: [
      "어깨 하강(숄더 패킹): 바를 당기기 전에 날개뼈를 아래로 지시 누르는 느낌(하강)을 먼저 준 후 당겨야 승모근의 개입을 줄이고 광배근에 자극을 집중할 수 있습니다.",
      "상체 각도 유지: 바를 당길 때 상체를 지나치게 뒤로 눕히면 등 하부나 허리에 부담이 갈 수 있으므로, 가슴만 살짝 열어준 상태의 각도를 일정하게 유지해야 합니다."
    ]
  },
  {
    id: 'common_3',
    brand: 'common',
    category: '팔 (이두)',
    name: '바벨컬 (바이셉스 컬) 머신',
    target: '상완이두근 (앞팔 알통)',
    images: [
      '/images/machine/common/bicepscurl.png', 
    ],
    image_des:'/images/machine/common/2_biceps.png',
    feature: [
      "의자 및 패드 조절: 겨드랑이가 패드 상단에 밀착되도록 의자 높이를 조절합니다. 앉았을 때 팔꿈치가 패드의 회전축과 일직선상에 놓여야 합니다.",
      "그립 잡기: 어깨너비 정도로 손잡이를 잡으며, 손바닥이 하늘을 향하도록(언더그립) 쥡니다. 상체는 곧게 펴고 등받이나 패드에 가슴을 밀착시킵니다.",
      "당기기 (수축): 호흡을 내쉬며 팔꿈치를 고정한 채 손잡이를 원을 그리듯 위로 당겨 올립니다. 이두근이 완전히 쥐어짜지는 느낌에 집중합니다.",
      "내리기 (이완): 호흡을 들이마시며 이두근의 저항을 느끼면서 천천히 무게를 내립니다. 팔꿈치가 완전히 펴지기 직전(약 95%)까지만 내려 근육의 긴장을 유지합니다."
    ],
    tip: [
      "팔꿈치 고정: 운동 중 팔꿈치가 패드에서 떨어지거나 앞뒤로 흔들리면 어깨(전면 삼각근)의 개입이 커지므로, 팔꿈치를 패드에 단단히 고정해야 합니다.",
      "손목 꺾임 주의: 무게를 들어 올릴 때 손목이 몸쪽으로 과도하게 꺾이면 전완근에 힘이 분산되고 손목 부상을 유발할 수 있으므로, 손목은 일직선으로 곧게 유지합니다."
    ]
  },
  {
    id: 'common_4',
    brand: 'common',
    category: '팔 (삼두)',
    name: '트라이셉스 익스텐션 머신 (시티드 삼두 머신)',
    target: '상완삼두근 (뒷팔)',
    images: [
      '/images/machine/common/tricepsextension.png',
    ],
    image_des:'/images/machine/common/2_tri.png',
    feature: [
      "의자 및 패드 조절: 겨드랑이나 팔 뒷부분이 패드에 안정적으로 밀착되도록 의자 높이를 조절합니다. 팔꿈치는 기구의 회전축과 수평이 되도록 맞춥니다.",
      "그립 잡기 및 자세: 패드에 팔을 얹고 손잡이를 잡습니다. 어깨를 낮추고 가슴을 편 상태에서 척추를 바르게 세워 자세를 고정합니다.",
      "밀기 (수축): 호흡을 내쉬며 팔꿈치를 축으로 삼아 손잡이를 앞으로 호를 그리듯 밀어냅니다. 삼두근이 완전히 쥐어짜질 때까지 팔을 펴줍니다.",
      "버티기 (이완): 호흡을 들이마시며 삼두근에 가해지는 무게를 버티면서 천천히 시작 자세로 돌아옵니다. 팔꿈치가 90도 이상 굽혀져 근육이 충분히 이완되도록 합니다."
    ],
    tip: [
      "팔꿈치 벌어짐 방지: 운동 중에 팔꿈치가 바깥쪽으로 벌어지면 어깨 관절에 무리가 가고 삼두근에 집중되는 자극이 분산되므로, 팔꿈치를 패드에 수평으로 단단히 고정해야 합니다.",
      "반동 제한 및 고정: 상체를 앞으로 숙이거나 체중을 실어 누르지 않도록 주의하며, 오직 팔꿈치 관절의 접고 폄(굴곡과 신전)만 이용하여 삼두근을 고립시켜야 합니다."
    ]
  },
  {
    id: 'common_5',
    brand: 'common',
    category: '어깨',
    name: '숄더 프레스 머신',
    target: '전면 및 측면 삼각근',
    images: [
      '/images/machine/common/shoulderpress.png',
    ],
    image_des:'/images/machine/common/2_shoulder.png',
    feature: [
      "의자 높이 조절: 앉았을 때 손잡이(그립)의 위치가 어깨선이나 귀 높이 정도에 오도록 의자 높이를 맞춥니다. 기구가 너무 낮으면 시작 시 어깨 관절에 무리가 갈 수 있습니다.",
      "기본 자세: 엉덩이와 등을 등받이에 바짝 붙이고, 허리는 아치형을 유지합니다. 발바닥은 지면에 단단히 고정하여 몸이 흔들리지 않도록 합니다.",
      "밀기 (수축): 호흡을 내쉬며 손잡이를 정수리 위쪽으로 수직으로 밀어 올립니다. 이때 팔꿈치를 100% 다 펴면 관절에 부담이 가므로 약 95%만 펴서 어깨 근육의 긴장을 유지합니다.",
      "내리기 (이완): 호흡을 들이마시며 무게를 버티는 느낌으로 천천히 손잡이를 내립니다. 손잡이가 귀 높이 정도까지 올 때까지 어깨 근육을 충분히 이완시켜 줍니다."
    ],
    tip: [
      "팔꿈치 위치 및 각도: 팔꿈치가 몸 뒤쪽으로 빠지면 어깨 전면 인대에 과도한 스트레스를 주어 부상을 유발할 수 있습니다. 팔꿈치는 살짝 앞을 향하게 하여 옆에서 봤을 때 전완(팔뚝)이 바닥과 수직을 이루도록 해야 합니다.",
      "승모근 개입 최소화: 무게를 밀어 올릴 때 어깨가 으쓱하며 위로 솟지 않도록 날개뼈를 아래로 눌러 고정한 상태(하강)에서 오직 어깨 근육의 힘으로만 밀어내야 합니다."
    ]
  },
  {
    id: 'common_6',
    brand: 'common',
    category: '하체',
    name: '레그 컬 머신 (라잉 레그 컬)',
    target: '햄스트링 (허벅지 뒷동작)',
    images: [
      '/images/machine/common/legcurl.png',
    ],
    image_des:'/images/machine/common/2_legcurl.png',
    feature: [
      "기구 조절: 엎드렸을 때 무릎 관절이 머신의 회전축과 일직선이 되도록 위치를 잡고, 롤러 패드가 아킬레스건 부근(복사뼈 바로 위)에 오도록 패드 길이를 조절합니다.",
      "기본 자세: 패드에 엎드려 손잡이를 꽉 잡고 골반과 허벅지를 벤치에 밀착시킵니다. 발끝은 몸쪽으로 당겨 당당하게 긴장감을 유지합니다.",
      "당기기 (수축): 호흡을 내쉬며 뒤꿈치로 엉덩이를 찬다는 느낌으로 패드를 강하게 끌어당깁니다. 햄스트링이 완전히 수축할 때까지 끝까지 접어줍니다.",
      "놓아주기 (이완): 호흡을 들이마시며 허벅지 뒤쪽의 저항을 천천히 느끼면서 다리를 폅니다. 무게추가 완전히 닿기 전, 무릎이 다 펴지기 직전까지만 내려 긴장을 유지합니다."
    ],
    tip: [
      "골반 들림 방지: 무게가 무거워지면 힘을 쓰기 위해 엉덩이(골반)가 위로 들리기 쉽습니다. 골반이 벤치에서 떨어지면 허리에 무리가 가고 햄스트링 자극이 줄어드므로, 골반을 벤치에 강하게 밀착시켜 고정해야 합니다.",
      "발목 각도 유지: 운동 중 발목이 펴지면(플란타 플렉션) 종아리 근육(비복근)의 개입이 커집니다. 발끝을 몸쪽으로 당긴 상태(도시 플렉션)를 유지해야 허벅지 뒤쪽에 자극을 고립시킬 수 있습니다."
    ]
  },
  {
    id: 'common_7',
    brand: 'common',
    category: '하체',
    name: '레그 익스텐션 머신',
    target: '대퇴사두근 (허벅지 앞쪽)',
    images: [
      '/images/machine/common/legextension.png',
    ],
    image_des:'',
    feature: [
      "기구 조절: 등받이를 조절하여 앉았을 때 오금(무릎 뒤쪽)이 의자 끝에 살짝 닿고 무릎 관절이 머신의 회전축과 일치하도록 합니다. 발목 패드는 발목 전면(정전이와 발등 사이)에 오도록 맞춥니다.",
      "기본 자세: 엉덩이와 등을 등받이에 바짝 밀착시키고 양 옆의 손잡이를 강하게 잡아 몸이 위로 뜨지 않도록 고정합니다. 발끝은 몸쪽으로 당겨 정렬합니다.",
      "차기 (수축): 호흡을 내쉬며 다리를 앞으로 호를 그리듯 쭉 뻗어 올립니다. 허벅지 앞쪽 근육이 단단하게 쥐어짜지는 느낌이 들 때까지 무릎을 폅니다.",
      "내리기 (이완): 호흡을 들이마시며 허벅지 앞쪽의 저항을 느끼면서 천천히 무릎을 굽혀 내립니다. 무게추가 완전히 닿기 직전까지 내려 근육의 긴장을 유지합니다."
    ],
    tip: [
      "엉덩이 고정: 다리를 들어 올릴 때 반동을 이용하면 골반과 엉덩이가 시트에서 들리게 됩니다. 이는 허리에 부담을 주고 대퇴사두근의 고립을 방해하므로, 손잡이를 아래로 당기며 엉덩이를 시트에 강력하게 고정해야 합니다.",
      "무릎 관절 보호: 다리를 찰 때 툭툭 던지듯 무릎을 튕기면 관절 인대에 큰 무리가 갑니다. 끝까지 올린 정점 수축 상태에서 1초간 머무른다는 느낌으로 부드럽고 통제된 동작으로 수행해야 합니다."
    ]
  },
  {
    id: 'common_8',
    brand: 'common',
    category: '등',
    name: '시티드 로우 머신',
    target: '광배근 등 (등 전체 및 두께)',
    images: [
      '/images/machine/common/seatedrow.png',
    ],
    image_des:'/images/machine/common/2_row.png',
    feature: [
      "기구 조절 및 기본 자세: 가슴 패드 높이를 조절하여 앉았을 때 패드 상단이 가슴 중앙 부근에 오도록 합니다. 발판에 발을 단단히 디디고 체중을 실어 엉덩이를 시트에 고정합니다.",
      "그립 잡기: 상체를 곧게 세우고 가슴 패드에 밀착한 상태에서 손잡이를 잡습니다. 이때 어깨가 앞으로 말리지 않도록 가슴을 활짝 열어줍니다.",
      "당기기 (수축): 호흡을 내쉬며 팔꿈치를 몸통 뒤로 보내준다는 느낌으로 손잡이를 배꼽이나 명치 아래 방향으로 당깁니다. 날개뼈(견갑골)를 가운데로 강하게 모아 등 근육을 쥐어짜줍니다.",
      "놓아주기 (이완): 호흡을 들이마시며 등의 긴장감을 유지한 채 천천히 팔을 앞으로 뻗어줍니다. 날개뼈가 자연스럽게 서로 멀어지며 등 근육이 길게 늘어나는 것을 느낍니다."
    ],
    tip: [
      "상체 고정 및 반동 제한: 손잡이를 당길 때 상체를 뒤로 과도하게 눕히거나, 팔을 뻗을 때 가슴 패드에서 몸이 완전히 떨어지면 허리에 무리가 가고 등 근육의 고립이 깨집니다. 가슴을 패드에 안정적으로 지지한 상태를 유지해야 합니다.",
      "팔꿈치 동선: 팔꿈치가 바깥쪽으로 너무 벌어지면 등 상부와 어깨 후면으로 자극이 분산됩니다. 광배근 하부와 등 전체의 두께감을 타겟팅하려면 팔꿈치를 옆구리에 스치듯 바짝 붙여서 당겨야 합니다."
    ]
  },
  {
    id: 'common_9',
    brand: 'common',
    category: '가슴',
    name: '펙덱 플라이 머신 (체스트 플라이)',
    target: '대흉근 안쪽 (가슴 모아주기 및 중간)',
    images: [
      '/images/machine/common/pecdeckfly.png',
    ],
    image_des:'/images/machine/common/2_fly.png',
    feature: [
      "의자 높이 및 가동범위 조절: 앉았을 때 손잡이를 잡은 손과 팔꿈치의 위치가 어깨선보다 약간 아래(가슴 중앙 높이)에 오도록 의자를 조절합니다. 기구의 가동범위는 어깨에 무리가 가지 않는 선으로 세팅합니다.",
      "기본 자세: 엉덩이와 등을 등받이에 바짝 붙이고 가슴을 위로 열어줍니다(흉추 신전). 손잡이를 잡고 팔꿈치를 살짝 굽혀 안쪽으로 둥글게 모은 형태(항아리를 안은 자세)를 만듭니다.",
      "모으기 (수축): 호흡을 내쉬며 겨드랑이에 힘을 주고 양손을 가슴 앞으로 모아줍니다. 손을 모은다는 느낌보다는 양쪽 이두근(알통)을 가슴 옆면에 밀착시킨다는 느낌으로 가슴 안쪽을 강하게 쥐어짜줍니다.",
      "벌리기 (이완): 호흡을 들이마시며 가슴 근육이 늘어나는 저항을 버티면서 천천히 팔을 바깥쪽으로 벌려줍니다. 이때 손이 어깨 뒤로 지나치게 넘어가지 않도록 주의하며 가슴 측면을 늘려줍니다."
    ],
    tip: [
      "팔꿈치 각도 고정: 운동을 진행하는 동안 굽혀놓은 팔꿈치의 각도가 변하면 안 됩니다. 팔을 펼치거나 접으면서 삼두근이나 이두근의 힘을 쓰지 않도록 팔꿈치 각도를 단단히 고정한 상태에서 어깨 관절의 움직임만 사용해야 합니다.",
      "어깨 부상 방지 (숄더 패킹): 날개뼈를 등받이에 고정하지 않고 팔을 모을 때 어깨가 앞으로 같이 따라 나가면(전인), 가슴이 아닌 어깨 전면 인대에 과도한 부담이 가고 부상을 입을 수 있으므로 어깨를 항상 뒤로 눌러 고정해야 합니다."
    ]
  }
];